export const mockHeaderData = (userName: string) => ({
    header: {
        app: {
            name: 'Xero',
            type: 'business',
        },
        page: {
            title: 'App Marketplace',
        },
        apps: [
            {
                name: 'My Xero',
                url: `https://my.xero.com/Go/Home`,
                openInNewWindow: true,
            },
        ],
        user: {
            name: userName,
            menu: {
                items: [
                    {
                        name: 'Edit profile',
                        url: `https://my.xero.com/Go/UserProfile`,
                    },
                    {
                        name: 'Xero Wizard',
                        icon: 'wizard',
                        url: `https://xero.com/training`,
                        openInNewWindow: true,
                    },
                    {
                        name: 'Logout',
                        icon: 'lock',
                        url: `/logout`,
                        type: 'logout',
                    },
                ],
            },
        },
        navigation: [
            {
                name: 'Dashboard',
                url: `https://go.xero.com/Dashboard`,
                navigationId: 'xrh-0',
            },
            {
                name: 'Business',
                url: `https://go.xero.com/Accounts/Receivable/Dashboard/`,
                navigationId: 'xrh-1',
            },
            {
                name: 'Accounting',
                navigationId: 'xrh-2',
                url: `https://go.xero.com/Bank`,
            },
            {
                name: 'Contacts',
                url: `https://go.xero.com/Contacts/Search`,
                navigationId: 'xrh-3',
            },
        ],
        addons: [
            {
                type: 'menu',
                name: 'Help',
                icon: 'help',
                scriptUrl: '/addon-demo/demo-menu-addon.js',
                options: {
                    items: [
                        {
                            name: 'Help Centre',
                            url: `https://help.xero.com/int`,
                            openInNewWindow: true,
                        },
                    ],
                },
            },
        ],
    },
    headerAssets: {
        basePath: 'https://edge.xero.com/platform/header/5.0.4/',
        js: {
            integrity: null,
            uri: 'https://edge.xero.com/platform/header/5.0.4/header.min.js',
        },
        css: {
            integrity: null,
            uri: 'https://edge.xero.com/platform/header/5.0.4/header-legacy.min.css',
        },
    },
});
